import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { AddCircle, Info, Visibility } from "@mui/icons-material";
import { Box, Button, Card, Stack, Typography } from "@mui/material";
import TableComponent from "../../../../../TableComponent/TableComponent";
import { getGeriatricDepressionScales } from "../../../../../../api/services/assessment";
import { formatDateField } from "../../../../../../base/FormatTime";
import { QK } from "../../../../../../base/qk";
import CreateGeriatricDepressionScaleModal from "./CreateGeriatricDepressionScale";
import AssessmentRiskTooltip from "../AssessmentRiskTooltip";
import { gdsRiskLevels } from "./geriatricDepressionScale.config";
import GeriatricDepressionScaleDetailsModal from "./GeriatricDepressionScaleDetailsModal";

const GeriatricDepressionScale = () => {
  const { id: clientID } = useParams();
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const { data: gdsAssessments, isLoading } = useQuery(
    [QK.geriatricDepressionScales, clientID],
    () => getGeriatricDepressionScales(clientID),
    { enabled: !!clientID }
  );

  const handleShowDetailsModal = (assessment) => {
    setSelectedAssessment(assessment);
    setShowDetailsModal(true);
  };

  const columns = [
    {
      field: "created_at",
      headerName: "Date",
      render: (value) => formatDateField(value),
    },
    { field: "client_name", headerName: "Service User" },
    { field: "created_by_name", headerName: "Created By" },
    { field: "score", headerName: "Score" },
    { field: "comments", headerName: "Comments" },
  ];

  const actions = [
    {
      icon: <Visibility />,
      color: "primary",
      handler: (assessment) => handleShowDetailsModal(assessment),
    },
  ];

  return (
    <div className="w-75 mx-auto">
      <Card sx={{ mb: 3 }}>
        <Box sx={{ bgcolor: "white", color: "black", p: 2 }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <Typography variant="h5">
                Geriatric Depression Scale Assessment
              </Typography>
              <AssessmentRiskTooltip
                assessmentType="Geriatric Depression Scale"
                riskLevels={gdsRiskLevels}
                icon={Info}
                iconColor="info"
                size="small"
                placement="right"
              />
            </Box>
            <Button
              variant="contained"
              startIcon={<AddCircle />}
              color="primary"
              onClick={() => setShowCreateModal(true)}
            >
              New Assessment
            </Button>
          </Stack>
        </Box>
      </Card>
      <div>
        <TableComponent
          data={gdsAssessments || []}
          columns={columns}
          actions={actions}
          isLoading={isLoading}
          size="small"
        />
      </div>

      <CreateGeriatricDepressionScaleModal
        open={showCreateModal}
        handleClose={() => setShowCreateModal(false)}
      />

      <GeriatricDepressionScaleDetailsModal
        open={showDetailsModal}
        handleClose={() => setShowDetailsModal(false)}
        assessment={selectedAssessment}
      />
    </div>
  );
};

export default GeriatricDepressionScale;
